import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { inventoryRouting } from './inventory.routing';
import { SharedModule } from '../shared/shared.module';
import { UserService } from '../shared/services';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


import {
    MaterialFormsModule,
    MaterialUserInterfaceModule,
} from 'ng2-material-components/ng2-material-components';

import { InventoryComponent } from './inventory.component';
import { ProductListComponent } from './product-list';
import { ProductListService } from './shared/services';
import { InventoryDetailComponent, InventoryDetailService } from './inventory-detail';
import { LocationEditQtyComponent, LocationEditQtyService } from './location-edit-qty';
import { ReportLossComponent, ReportLossService } from './report-loss';
import { ProductTransferComponent } from './product-transfer';
import { ProductsTransferComponent } from './products-transfer';
import { TransferOverviewComponent, TransferService } from './transfer-overview';
import { ProductTransferSelectedComponent } from './products-transfer-selected';
import { TransferLocationsComponent } from './transfer-locations';
import { ProductQtyComponent } from './product-qty';
import { ProductsFilterSheetComponent, InputFilterSheetComponent } from './shared/ui';
import { TransferHistoryComponent, TransferHistoryService } from './transfer-history';
import { TransferDetailComponent, TransferDetailService } from './transfer-detail';


@NgModule({
    imports: [
        CommonModule,
        MaterialFormsModule,
        MaterialUserInterfaceModule,
        inventoryRouting,
        SharedModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [
        InventoryComponent,
        ProductListComponent,
        ProductsFilterSheetComponent,
        InventoryDetailComponent,
        InputFilterSheetComponent,
        LocationEditQtyComponent,
        ReportLossComponent,
        ProductTransferComponent,
        TransferOverviewComponent,
        ProductTransferSelectedComponent,
        TransferLocationsComponent,
        ProductsTransferComponent,
        ProductQtyComponent,
        TransferHistoryComponent,
        TransferDetailComponent
    ],
    declarations: [
        InventoryComponent,
        ProductListComponent,
        ProductsFilterSheetComponent,
        InventoryDetailComponent,
        InputFilterSheetComponent,
        LocationEditQtyComponent,
        ReportLossComponent,
        ProductTransferComponent,
        TransferOverviewComponent,
        ProductTransferSelectedComponent,
        TransferLocationsComponent,
        ProductsTransferComponent,
        ProductQtyComponent,
        TransferHistoryComponent,
        TransferDetailComponent
    ],
    providers: [
        ProductListService,
        InventoryDetailService,
        UserService,
        LocationEditQtyService,
        ReportLossService,
        TransferService,
        TransferHistoryService,
        TransferDetailService
    ],
})
export class InventoryModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/inventory.module.ts